import { useEffect, useRef, useState } from 'react'
import {
  FPS_SAMPLE_WINDOW_MS,
  FPS_TARGET,
  GRAPH_SAMPLE_INTERVAL_MS,
  LIVE_TICK_INTERVAL_MS,
  MAX_SAMPLES
} from './performanceMonitorBar.constants'
import { FpsSample } from './performanceMonitorBar.types'

export const useFps = () => {
  const [fps, setFps] = useState<number | null>(null)
  const [history, setHistory] = useState<FpsSample[]>([])
  const frameTimestampsRef = useRef<number[]>([])

  useEffect(() => {
    let rafId = 0

    const tick = (now: number) => {
      const windowStart = now - FPS_SAMPLE_WINDOW_MS
      frameTimestampsRef.current = [
        ...frameTimestampsRef.current.filter(t => t >= windowStart),
        now
      ]
      rafId = requestAnimationFrame(tick)
    }

    rafId = requestAnimationFrame(tick)

    const computeFps = (): number => {
      const timestamps = frameTimestampsRef.current
      if (timestamps.length < 2) return 0
      const span = timestamps[timestamps.length - 1] - timestamps[0]
      if (span <= 0) return 0
      return Math.min(FPS_TARGET, ((timestamps.length - 1) / span) * 1000)
    }

    const liveInterval = setInterval(() => {
      setFps(computeFps())
    }, LIVE_TICK_INTERVAL_MS)

    const sampleInterval = setInterval(() => {
      const sample: FpsSample = {
        timestamp: Date.now(),
        value: computeFps()
      }
      setHistory(prev => {
        const updated = [...prev, sample]
        return updated.length > MAX_SAMPLES
          ? updated.slice(updated.length - MAX_SAMPLES)
          : updated
      })
    }, GRAPH_SAMPLE_INTERVAL_MS)

    return () => {
      cancelAnimationFrame(rafId)
      clearInterval(liveInterval)
      clearInterval(sampleInterval)
    }
  }, [])

  return { fps, history }
}
